import { render, staticRenderFns } from "./AddLocalBankAccount.vue?vue&type=template&id=83e64e06"
import script from "./AddLocalBankAccount.vue?vue&type=script&lang=js"
export * from "./AddLocalBankAccount.vue?vue&type=script&lang=js"
import style0 from "./AddLocalBankAccount.vue?vue&type=style&index=0&id=83e64e06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports